export default class hr {
	static translations = {
		labels: {
			total: 'Ukupno',
			others: 'drugih',
			selectAll: 'Označi sve',
			logout: 'Odjava',
			profile: 'Profil',
			settings: 'Postavke',
			yourData: 'Vaši podaci',
			rowsPerPage: 'Redaka po stranici:',
			totalRecords: 'Ukupno zapisa:',
			all: 'Svi',
			noResults: 'Nema rezultata.',
			of: 'od',
			from: 'od',
			to: 'do',
			uploadInProgress: 'Slanje u tijeku.',
			new: 'Novo',
			dragdrop: 'Povucite datoteke ovdje',
			dragdropSingle: 'Povucite datoteku ovdje',
			page: 'Stranica',
			additionalFilters: 'Dodatni filteri',
			yes: 'Da',
			showUnactives: 'Prikaži neaktivne',
			noData: 'Nema podataka',
			edit: 'Uredi',
			noActivities: 'Nema aktivnosti',
			activities: 'Aktivnosti',
			hourRateType: 'Tip satnice:',
			certificateType: 'Tip certifikata: ',
			loyaltyTransactionType: 'Vrsta loyalty transakcije: ',
			sum: 'Ukupno: ',
			months: ' mjeseci',
			manualInsert: 'Ručni unos',
			numberOfRatings: 'Broj ocjena: ',
			totalExperience: 'Ukupno iskustvo: ',
			buyerType: 'Tip kupca:',
			theme: 'Tema',
			light: 'Svijetla',
			dark: 'Tamna',
			fontSize: 'Veličina fonta',
			large: 'Velika',
			small: 'Mala',
			standard: 'Standard',
			contrast: 'Kontrast',
			high: 'Visok',
			dyslexicFont: 'Disleksički font',
			no: 'Ne',
			paymentContract: 'Platni ugovor: ',
			obSurveyNumber: 'OB-26/03.04',
		},
		modules: {
			login: 'Prijava',
			dashboard: 'Kontrolna ploča',
			profile: 'Moj profil',
			userAccounts: 'Korisnički računi',
			newUserAccount: 'Novi korisnički račun',
			showcase: 'Showcase',
			projects: 'Projekti',
			teachers: 'Predavači',
			partners: 'Vanjski partneri',
			newTeacher: 'Novi predavač',
			otherCodebooks: 'Ostali šifrarnici',
			newPartner: 'Novi partner',
			certificates: 'Certifikati',
			newCertificate: 'Novi certifikat',
			codebooks: 'Šifrarnici',
			classrooms: 'Učionice',
			newClassroom: 'Nova učionica',
			ships: 'Plovila',
			newShip: 'Novo plovilo',
			courses: 'Tečajevi',
			newCourse: 'Novi tečaj',
			candidates: 'Kandidati',
			newCandidate: 'Novi kandidat',
			equipments: 'Inventar/Nabava',
			newEquipment: 'Novi inventar',
			contracts: 'Ugovori',
			newContract: 'Novi ugovor',
			brevetsRenewal: 'Zamjena breveta',
			newBrevetRenewal: 'Nova zamjena breveta',
			plannedCourses: 'Planirani tečajevi',
			plans: 'Planovi',
			newPlannedCourse: 'Novi planirani tečaj',
			preregistrations: 'Predupisi',
			newPreregistration: 'Novi predupis',
			issuedCertificates: 'Izdani certifikati',
			weeklySchedule: 'Tjedni raspored',
			gantt: 'Mjesečni raspored',
			surveys: 'Ankete',
			internalDocuments: 'Interni dokumenti',
			paymentContracts: 'Platni ugovori',
			newPaymentContract: 'Novi platni ugovor',
			stats: 'Statistika',
			administration: 'Administracija',
			annualPlan: 'Godišnji plan',
		},
		fields: {
			loginType: 'Način prijave',
			openPaymentContracts: 'Otvoreni platni ugovori',
			language: 'Jezik',
			teachers: 'Predavači',
			additionalAmount: 'Dodatna vrijednost',
			totalNumberOfCourses: 'Ukupni broj tečajeva',
			shareOfCostInTotalIncome: 'Udio troška u ukupnom prihodu (%)',
			shareOfIncomeInTotalIncome: 'Udio prihoda u ukupnom prihodu (%)',
			shareOfProfitInTotalProfit: 'Udio dobiti u ukupnoj dobiti (%)',
			shareOfNumberOfCandidatesInTotalNumberOfCandidates: 'Udio br. kand. u ukupnom broju kand. (%)',
			courses: 'Tečajevi',
			incomePercantage: 'Udio prihoda (%)',
			costPercantage: 'Udio troška (%)',
			profitPercantage: 'Udio dobiti (%)',
			registrationsPercantage: 'Udio br. kandidata (%)',
			total: 'Ukupno (€)',
			heldIn: 'Održano u',
			unlimitedValidity: 'Neograničena valjanost',
			owes: 'Duguje',
			itemType: 'Vrsta stavke',
			cost: 'Trošak (€)',
			profit: 'Dobit (€)',
			search: 'Pretraga',
			add: 'Dodaj',
			id: 'ID',
			oib: 'Nacionalni identifikator (OIB)',
			iban: 'IBAN',
			firstName: 'Ime',
			lastName: 'Prezime',
			email: 'E-mail',
			address: 'Adresa',
			postalCode: 'Poštanski broj',
			city: 'Grad',
			country: 'Država',
			phone: 'Kontakt telefon',
			password: 'Lozinka',
			confirmPassword: 'Ponovite lozinku',
			rememberMe: 'Zapamti prijavu',
			passwordChange: 'Promjena lozinke',
			oldPassword: 'Stara lozinka',
			newPassword: 'Nova lozinka',
			newPasswordConfirmation: 'Ponovljena nova lozinka',
			active: 'Aktivan',
			locked: 'Zaključan',
			role: 'Uloga',
			selectHeaders: 'Odaberi stupce',
			name: 'Naziv',
			user: 'Korisnik',
			dateCreated: 'Datum kreiranja',
			dateUpdated: 'Datum ažuriranja',
			deadline: 'Rok',
			amount: 'Iznos (€)',
			amountNeto: 'Iznos neto (€)',
			amountBruto: 'Iznos bruto (€)',
			amountForExpiration: 'Iznos za istek',
			title: 'Titula',
			remark: 'Primjedba',
			remarkPraise: 'Primjedba/Pohvala',
			remarkPraise_eng: 'Remarks',
			office: 'Poslovnica',
			offices: 'Poslovnice',
			rank: 'Čin',
			ranks: 'Činovi',
			department: 'Odjel',
			departments: 'Odjeli',
			equipmentType: 'Vrsta opreme',
			equipmentTypes: 'Vrste opreme',
			contactPerson: 'Kontakt osoba',
			business: 'Djelatnost',
			headquarter: 'Sjedište',
			note: 'Bilješka',
			rabat: 'Rabat',
			buyer: 'Kupac',
			supplier: 'Dobavljač',
			type: 'Vrsta',
			price: 'Cijena (€)',
			location: 'Lokacija',
			correctional: 'Popravni',
			capacity: 'Kapacitet',
			partner: 'Vanjski partner',
			company: 'Kompanija',
			pricePerDay: 'Cijena po danu (€)',
			locationPort: 'Lokacija - Luka',
			code: 'Šifra',
			hours: 'Sati',
			totalDiscount: 'Ukupan popust (€)',
			totalIncome: 'Ukupan prihod (€)',
			durationMonths: 'Trajanje (mjeseci)',
			validityYears: 'Valjanost (godine)',
			studentsLimit: 'Broj polaznika',
			durationDays: 'Trajanje (dani)',
			durationHours: 'Trajanje (sati)',
			certificate: 'Certifikat',
			concessionValidityDate: 'Valjanost koncesije',
			notifications: 'Obavijesti',
			description: 'Opis',
			prerequisites: 'Preduvjeti',
			dateOfBirth: 'Datum rođenja',
			placeOfBirth: 'Mjesto rođenja',
			loyaltyPoints: 'Loyalty bodovi',
			countryOfBirth: 'Država rođenja',
			county: 'Županija',
			entryDate: 'Datum ulaska',
			incomingInspection: 'Nadolazeća kontrola',
			writeOff: 'Otpis',
			writtenOff: 'Otpisano',
			writeOffDate: 'Datum otpisa',
			classroom: 'Učionica',
			inventoryNumber: 'Inv broj',
			date: 'Datum',
			activityDescription: 'Opis aktivnosti',
			inspectionFrequency: 'Učestalost kontrole',
			newInspectionDate: 'Datum sljedeće kontrole',
			equipment: 'Oprema',
			module: 'Modul',
			documents: 'Dokumenti',
			activities: 'Aktivnosti',
			activity: 'Aktivnost',
			validityMonths: 'Valjanost (mjeseci)',
			testimonial: 'Potvrdnica',
			testimonialUnitPrice: 'Jd cijena potvrdnice (€)',
			bank: 'Banka',
			contractNumber: 'Broj ugovora',
			startDate: 'Datum početka',
			endDate: 'Datum završetka',
			contractType: 'Vrsta ugovora',
			teacher: 'Predavač',
			created: 'Kreirao',
			programT1: 'Program za T1',
			programT2: 'Program za T2',
			programT3: 'Program za T3',
			programT4: 'Program za T4',
			t1: 'T1',
			t2: 'T2',
			t3: 'T3',
			t4: 'T4',
			signedContractUpload: 'Upload potpisanog ugovora:',
			brevetNumber: 'Broj breveta',
			candidate: 'Kandidat',
			document: 'Dokument',
			loyaltyConsent: 'Loyalty privola',
			gdprConsent: 'GDPR privola',
			loyaltyCardNumber: 'Broj loyalty kartice',
			loyaltyCard: 'Loyalty kartica',
			courseCode: 'Šifra tečaja',
			courseName: 'Naziv tečaja',
			preregistration: 'Predupis',
			registration: 'Upis',
			status: 'Status',
			minStudents: 'Minimalni broj polaznika',
			maxStudents: 'Maksimalni broj polaznika',
			course: 'Tečaj',
			examDate: 'Datum ispita',
			studentSignatureList: 'Potpisna lista studenata',
			teacherSignatureList: 'Potpisna lista predavača',
			existingCandidate: 'Postojeći kandidat',
			notified: 'Obaviješten',
			plannedCourse: 'Planirani tečaj',
			rbr: 'R.br.',
			proof: 'Dokaz',
			unitPrice: 'Jd cijena (€)',
			unitPriceNeto: 'Jd cijena neto (€)',
			quantity: 'Količina',
			sum: 'Ukupno (€)',
			startAppointmentTime: 'Početak termina',
			endAppointmentTime: 'Kraj termina',
			appointmentTime: 'Vrijeme termina (od/do)',
			participant: 'Sudionik',
			duration: 'Trajanje',
			hoursAmount: 'Količina sati',
			billing: 'Naplata',
			hourRateType: 'Tip sati',
			hourRate: 'Satnica (€)',
			author: 'Autor',
			plannedCourseNumber: 'Broj planiranog tečaja',
			file: 'Datoteka',
			provisions: 'Odredbe',
			idCardOrPassportNumber: 'Broj osobne ili putovnice',
			updatedAt: 'Vrijeme posljedne izmjene',
			courseNumber: 'Broj tečaja',
			appointmentLocation: 'Lokacija termina',
			issueDate: 'Datum izdavanja',
			expirationDate: 'Datum isteka',
			issuedIn: 'Izdano u',
			twoSignings: 'Dva potpisa',
			threeSignings: 'Tri potpisa',
			certificateNumber: 'Broj certifikata',
			classroomShip: 'Učionica/Plovilo',
			subtract: 'Oduzmi',
			paymentContract: 'Platni ugovor',
			finalState: 'Završno stanje',
			stateChange: 'Promjena stanja',
			startingState: 'Početno stanje',
			completedSurveys: 'Ispunjene ankete',
			completedSurveyPercentage: 'Postotak ispunjenih anketa',
			averageGrade: 'Prosječna ocjena',
			surveyCompleted: 'Anketa ispunjena',
			question: 'Pitanje',
			amountOfRatings: 'Broj ocjena',
			rating: 'Ocjena',
			companyName: 'Naziv tvrtke',
			shipType: 'Tip plovila',
			lastModified: 'Posljednji izmjenio',
			contractTotalNeto: 'Iznos ugovora neto (€)',
			contractTotalBruto: 'Iznos ugovora bruto (€)',
			totalBruto: 'Ukupno bruto',
			payedBruto: 'Plaćeno bruto (€)',
			leftNeto: 'Preostalo neto (€)',
			leftBruto: 'Preostalo bruto (€)',
			loyaltyDiscount: 'Loyalty popust',
			discount: 'Popust',
			deleteAllLeftCourses: 'Izbriši sve preostale tečajeve',
			amountForDeletion: 'Količina za brisanje',
			unitDiscount: 'Jd popust (€)',
			unitDiscount2: 'Jd popust (%)',
			unitDiscountNeto: 'Jd popust neto(€)',
			neto: 'Neto (€)',
			totalNeto: 'Ukupno neto',
			payed: 'Uplaćeno (€)',
			payed2: 'Plaćeno',
			left: 'Preostalo (€)',
			paymentContractItem: 'Stavka platnog ugovora',
			contractItemType: 'Vrsta stavke ugovora',
			billNumber: 'Broj računa',
			netIncome: 'Neto prihod (€)',
			netDiscount: 'Neto popust (€)',
			netProfit: 'Neto dobit (€)',
			incomeCandidate: 'Prihod po kandidatu (€)',
			costCandidate: 'Trošak po kandidatu (€)',
			profitCandidate: 'Dobit po kandidatu (€)',
			discountCandidate: 'Popust po kandidatu (€)',
			testimonalNumber: 'Broj potvrdnice',
			passed: 'Položio',
			priceNeto: 'Cijena neto (€)',
			priceBruto: 'Cijena bruto (€)',
			testimonialAmount: 'Broj potvrdnica',
			communicatePrice: 'Komuniciraj cijenu (€)',
			vat: 'PDV (%)',
			vat2: 'PDV',
			totalVat: 'Iznos PDV-a (€)',
			bruto: 'Bruto (€)',
			paymentContractStatus: 'Status platnog ugovora',
			ratingsExplaination: 'Objašnjenje ocjena',
			ratingsExplainationAmount: 'Broj objašnjenja ocjene',
			candidateWithPaymentContract: 'Kandidat s platnim ugovorom',
			partnerWithPaymentContract: 'Vanjski partner s platnim ugovorom',
		},
		alerts: {
			candidateDontExistInDatabase: 'Kandidat ne postoji u bazi podataka.',
			candidateExistInDatabase: 'Kandidat postoji u bazi podataka! ID: %id% Ime: %name%',
			fileAdd: 'Datoteka je dodana.',
			oibExists: 'Kandidat sa ovim OIB-om već postoji.',
			preregistrationNotFound: 'Predupis za ovog kandidata nije pronađen.',
			candidateAlreadyHavePlannedCourse: 'Kandidatu je već dodijeljen planirani tečaj. Osvježite stranicu.',
			selectedPlannedCourseNoAppointments: 'Odabrani planirani tečaj nema niti jedan termin.',
			officeConcessionExists: 'Koncesija za ovaj ured već postoji.',
			approvalExists: 'Odobrenje već postoji.',
			deletionQuestion: 'Jeste li sigurni da želite izbrisati ovaj zapis?',
			fileDeletionQuestion: 'Jeste li sigurni da želite izbrisati ovu datoteku?',
			photoDeletionQuestion: 'Jeste li sigurni da želite izbrisati ovu fotografiju?',
			firstNameMissing: 'Molimo vas unesite ime.',
			nameMissing: 'Molimo vas unesite naziv.',
			lastNameMissing: 'Molimo vas unesite prezime.',
			lengthError: 'U polje %field% možete unijeti maksimalno %length% znakova.',
			quantityError: 'Maksimalna vrijednost polja %field% je %max%.',
			negativeValueError: 'U polje %field% možete unijeti samo pozitivne vrijednosti.',
			emailMissing: 'Molimo vas unesite e-mail.',
			emailFailFormat: 'Email je neispravan.',
			passwordMissing: 'Molimo vas unesite lozinku.',
			passwordConfirmationFail: 'Lozinke se ne podudaraju.',
			passwordResetSuccess: 'Nova lozinka poslana je na unesenu e-mail adresu.',
			passwordResetFail: 'Nije pronađen korisnik sa unesenom e-mail adresom.',
			passwordLength: 'Lozinka mora imati minimalno 8 znakova.',
			passwordLetters: 'Lozinka mora imati barem jedno slovo.',
			passwordDigits: 'Lozinka mora imati barem jednu znamenku.',
			passwordOthers: 'Lozinka mora imati barem jedan poseban znak.',
			loginFail: 'Neispravni podaci za prijavu.',
			basicUpdate: 'Promjene spremljene.',
			basicDelete: 'Zapis izbrisan.',
			basicAdd: 'Zapis dodan.',
			basicError: 'Došlo je do greške na poslužitelju.',
			fieldMissing: 'Ovo polje je obavezno',
			deleteError: 'Ovaj zapis ne možete izbrisati.',
			leaveQuestion: 'Jeste li sigurni da želite otići bez spremanja?',
			generatePasswordQuestion: 'Jeste li sigurni da želite generirati novu lozinku ovom korisniku?',
			recordLocked: 'Ovaj zapis je zaključan jer ga uređuje %name%.',
			formatError: 'Format vrijednosti %value% nije ispravan.',
			fieldError: 'Ovo polje je obavezno.',
			buyerOrSupplier: 'Odaberite barem jedno od sljedećih polja: Dobavljač ili Kupac',
			valueError: 'Vrijednost polja %field% mora biti između %min% i %max%.',
			deleteTestimonialQuestion: 'Jeste li sigurni da želite izbrisati broj potvrdnice kandidata %candidate%?',
			inspectionDeleteSuccess: 'Kontrola uspješno obrisana.',
			documentDeleteSuccess: 'Dokument uspješno obrisan.',
			fileDeleteSuccess: 'Datoteka uspješno obrisana.',
			fileMissing: 'Molimo vas priložite datoteku.',
			gdprFileMissing: 'Molimo vas priložite datoteku GDPR privole.',
			loyaltyFileMissing: 'Molimo vas priložite datoteku Loyalty privole.',
			cancelCourseQuestion:
				'Jeste li sigurni da želite otkazati ovaj tečaj? Jednom otkazan, tečaj se ne može ponovo aktivirati.',
			concludeCourseQuestion:
				'Jeste li sigurni da želite zaključiti ovaj tečaj? Jednom zaključen, tečaj se ne može ponovo aktivirati.',
			disenrollmentManuallyAddedCandidate: 'Želite li dodati predupis za ovog kandidata koji je ručno upisan?',
			deleteRegistrationOfManuallyAddedCandidate:
				'Upis ručno dodanog kandidat će se izbrisati. Želite li nastaviti?',
			startCourseQuestion: 'Želite li započeti ovaj tečaj?',
			appointmentTimeFormat: 'Vremena moraju biti upisana u formatu hh:mm.',
			appointmentTimeFormat2: 'Raspon vremena mora biti između 00:00 i 23:59.',
			appointmentTimeFormat3: 'Vrijeme početka ne može biti poslije vremena završetka.',
			appointmentTimeFormat4: 'Vrijeme početka i završetka mora završavati sa 00, 15, 30 ili 45 minuta.',
			hoursError: 'Sati moraju završavati na .00, .25, .50 ili na .75.',
			courseModuleError: 'Obavezno je dodati barem jedan modul na tečaj.',
			onlyNumbersError: 'U polje %field% se unosi brojčana vrijednost.',
			candidateError: 'Potrebno je odabrati barem jednog kandidata.',
			gdprCandidateDeletionQuestion:
				'Iniciranjem ove akcije svi osobni podaci kandidata biti će izgubljeni. Jednom potvrđena, ova akcija ne može se poništiti. Želite li nastaviti?',
			userExistsWithGivenEmail: 'Već postoji korisnik s navedenim e-mailom.',
			generateSurveysQuestion:
				'Jeste li sigurni da želite generirati ankete za ovaj tečaj? Link ankete će e-mailom biti poslan svim polaznicima tečaja.',
			surveyGenerationSuccess: 'Ankete su uspješno generirane.',
			closeContractQuestion:
				'Zatvaranjem ugovora nećete moći dodavati, uređivati i brisati stavke ugovora. Želite li nastaviti?',
			openContractQuestion: 'Želite li otvoriti ovaj platni ugovor?',
			plannedCourseEndDateError: 'Datum završetka planiranog tečaja ne može biti prije datuma početka.',
			candidateAlreadyEnrolled: 'Kandidat je već upisan na ovaj tečaj.',
			coursePriceUndefiend: 'Neto cijena odabranog tečaja nije definirana u šifrarniku Tečajevi.',
			addAtLeastOneCandidate: 'Za predpregled je potrebno dodati barem jednog kandidata.',
			loyaltyCardExists: 'Već postoji kandidat s navedenim brojem kartice.',
			oldPasswordFail: 'Stara lozinka je netočna.',
			registrationOnThisCourse: 'Želite li kandidata upisati na ovaj tečaj?',
			candidateAlreadyHavePaymentContract: 'Kandidat je već upisan sa platnim ugovorom. Osvježite stranicu.',
			candidateCreatedButIsNotEnrolled: 'Kandidat je dodan u bazu, ali nije upisan na tečaj.',
			addPlannedCourseToPreregistredCandidate: 'Dodajte ovaj tečaj kao kandidatov planirani tečaj?',
			sendSurveysAgainAlert:
				'Ponovno slanje ankete izbrisat će sve postojeće ankete, uključujući i ocjene koje su kandidati možda već ispunili. Jeste li sigurni da želite obrisati postojeće ankete i poslati nove na e-mail adrese kandidata?',
			surveySendingSuccess: 'Ankete su uspješno poslane.',
			selectedPaymentContractsClosed: 'Odabrani platni ugovori su zatvoreni.',
		},
		buttons: {
			newCandidateAndRegistration: 'Novi kandidat + upis',
			enrolledCandidatesView: 'Pregled upisanih kandidata',
			copy: 'Kopiraj',
			saveAndClose: 'Spremi i izađi',
			getMonthlyPlan: 'Preuzmi mjesečni plan',
			copySchedule: 'Kopiraj raspored',
			choose: 'Odaberi',
			login: 'Prijava',
			logout: 'Odjava',
			profile: 'Profil',
			new: 'Novo',
			skip: 'Preskoči',
			save: 'Spremi',
			save_eng: 'Save',
			edit: 'Uredi',
			add: 'Dodaj',
			cancel: 'Odustani',
			yes: 'Da',
			no: 'Ne',
			ok: 'OK',
			delete: 'Briši',
			back: 'Natrag',
			passed: 'Položio',
			forgottenPassword: 'Zaboravili ste lozinku?',
			filter: 'Filtriraj',
			cancelFilter: 'Poništi filtriranje',
			all: 'Sve',
			generateNewPassword: 'Pošalji novu lozinku',
			send: 'Pošalji',
			partial: 'Djelomično',
			newInspection: 'Nova kontrola',
			classroomReport: 'Izvještaj učionice',
			generateContract: 'Generiraj ugovor',
			cancelContract: 'Storniraj ugovor',
			close: 'Zatvori',
			close_eng: 'Close',
			loadClosedInspections: 'Učitaj zatvorene kontrole',
			deleteTestimonial: 'Izbriši potvrdnicu',
			addDocument: 'Dodaj dokument',
			concludeCourse: 'Zaključi tečaj',
			cancelCourse: 'Otkaži tečaj',
			addToTheBase: 'Dodaj u bazu',
			manuallyEnroll: 'Ručno upiši',
			addCost: 'Dodaj trošak',
			startCourse: 'Započni tečaj',
			addAppointment: 'Dodaj termin',
			teacherSigningList: 'Potpisna lista predavača',
			candidateSigningList: 'Potpisna lista kandidata',
			addActivity: 'Dodaj aktivnost',
			issueCertificate: 'Izdaj certifikat',
			preview: 'Predpregled',
			gdprDelete: 'GDPR Brisanje',
			previousMonth: 'Prethodni mjesec',
			nextMonth: 'Sljedeći mjesec',
			manuallyAdjust: 'Ručno prilagodi',
			generateSurveys: 'Generiraj ankete',
			addManually: 'Ručni unos',
			addNavigation: 'Dodaj navigaciju',
			addItem: 'Dodaj stavku',
			addBill: 'Dodaj račun',
			closeContract: 'Zatvori ugovor',
			openPaymentContract: 'Otvori platni ugovor',
			issueCertificates: 'Izdaj certifikate',
			enrolledCandidatesRegister: 'Registar polaznika tečaja',
			candidatesRegister: 'Registar polaznika',
			saveAndCreateInvoice: 'Spremi i izradi račun',
			sendSurveysAgain: 'Ponovno pošalji ankete',
			bulkLock: 'Grupno zaključavanje',
			lock: 'Zaključaj',
		},
		tooltips: {
			checkIfCandidateExistsInDatabase: 'Provjeri postoji li kandidat u bazi podataka',
			unreadPreregistrations: 'Nepročitani predupisi',
			copyPreregistration: 'Kopiraj predupis',
			editCandidate: 'Uredi kandidata',
			downloadFile: 'Preuzmi datoteku',
			getCertificatePdf: 'Preuzmi Pdf certifikata',
			edit: 'Uredi',
			add: 'Dodaj',
			delete: 'Briši',
			filter: 'Filter',
			logout: 'Logout',
			settings: 'Postavke',
			openInNewTab: 'Otvori u novom tabu',
			excel: 'Excel export',
			resetFilters: 'Poništi filtere',
			additionalFilters: 'Dodatni filteri',
			selectHeaders: 'Odaberi stupce',
			activate: 'Aktiviraj',
			uploadFile: 'Upload datoteku',
			removeFile: 'Izbriši datoteku',
			deleteNextInspectionDate: 'Izbriši datum sljedeće kontrole',
			createPaymentContract: 'Kreiraj platni ugovor',
			editInspection: 'Uredi kontrolu',
			deleteInspection: 'Izbriši kontrolu',
			deleteDocument: 'Izbriši dokument',
			addEquipmentActivityNote: 'Dodaj bilješku',
			addNewDocument: 'Dodajte novi dokument',
			addModule: 'Dodaj modul',
			enrollCandidate: 'Upiši kandidata',
			switchToPreregistration: 'Prebaci kandidata u predupis',
			deleteCost: 'Izbriši trošak',
			deleteActivity: 'Izbriši aktivnost',
			deleteIssuedCertificate: 'Izbriši izdani certifikat',
			deleteNavigation: 'Izbriši navigaciju',
			deleteItem: 'Izbriši stavku',
			passed: 'Položio',
			deleteTestimonial: 'Izbriši potvrdnicu',
			userManual: 'Korisničke upute',
			openPaymentContract: 'Otvori platni ugovor',
			addApproval: 'Dodaj odobrenje',
			addConcession: 'Dodaj koncesiju',
			addPlannedCourse: 'Dodaj planirani tečaj',
			testimonialNumber: 'Broj potvrdnice: ',
			deletePlannedCourse: 'Izbriši planirani tečaj',
			courseOnEnglish: 'Tečaj na engleskom.',
			courseOnHungarian: 'Tečaj na mađarskom.',
		},
		texts: {
			passwordReset: `Ako ste zaboravili lozinku ovdje možete zatražiti slanje e-maila sa novom lozinkom.`,
			teacherSurveyQuestion: 'Kako biste ocijenili instruktora ',
			teacherSurveyQuestion_eng: 'How do you rate the expertise of the instructor ',
			surveyQuestion1: 'Kako biste ocijenili administrativno osoblje?',
			surveyQuestion1_eng: 'How satisfied are you with the skill and knowledge of our administration staff?',
			surveyQuestion2: 'Kako ste sveukupno zadovoljni tečajem?',
			surveyQuestion2_eng: 'How satisfied are you with the training overall?',
			pleaseExplainRating: 'Molimo obrazložite ocjenu',
			pleaseExplainRating_eng: 'Please explain the rating ',
			surveyCompletedSuccessfully: 'Uspješno ste popunili anketu.',
			surveyCompletedSuccessfully_eng: 'You have successfully completed the survey.',
			tenPointsAddedToYourAccount: 'Na vaš saldo dodano je 10 bodova.',
			tenPointsAddedToYourAccount_eng: '10 points have been added to your balance.',
			surveyRatingInfo: 'Ocijenite ocjenom od 1 do 5, gdje je 1 najlošije, a 5 najbolje',
			surveyRatingInfo_eng: 'Rate on a scale of 1 to 5, where 1 is the worst and 5 is the best',
		},
		tabs: {
			courseTeachers: 'Predavači na tečaju',
			basicInfo: 'Osnovne informacije',
			candidatesEmployees: 'Kandidati (zaposlenici)',
			ships: 'Plovila',
			template: 'Predložak',
			certificates: 'Certifikati',
			courses: 'Tečajevi',
			documents: 'Dokumenti',
			candidates: 'Kandidati',
			partners: 'Vanjski partneri',
			appointments: 'Termini',
			schedule: 'Raspored',
			teachers: 'Predavači',
			costs: 'Troškovi',
			contracts: 'Ugovori',
			activities: 'Aktivnosti',
			loyalty: 'Loyalty',
			surveys: 'Ankete',
			ratings: 'Ocjene',
			navigation: 'Navigacija',
			paymentContracts: 'Platni ugovori',
			attendedCourses: 'Odslušani tečajevi',
		},
		titles: {
			statsOffices: 'Statistika poslovnica',
			statsCosts: 'Statistika troškova',
			courseTeachers: 'Predavači na tečaju',
			candidateBrevets: 'Brevete kandidata',
			copySchedule: 'Kopiraj raspored',
			editingInspection: 'Ažuriranje kontrole',
			closingInspection: 'Zatvaranje kontrole',
			closedInspections: 'Zatvorene kontrole',
			classroomInformations: 'Informacije o učionici',
			teacherInformations: 'Informacije o predavaču',
			shipInformations: 'Informacije o plovilu',
			courseInformations: 'Informacije o tečaju',
			equipmentInformations: 'Informacije o inventaru',
			partnerInformations: 'Informacije o vanjskom partneru',
			candidateInformations: 'Informacije o kandidatu',
			certificateInformations: 'Informacije o certifikatu',
			userAccountInformations: 'Informacije o korisničkom računu',
			modules: 'Moduli',
			testimonialNumber: 'Broj potvrdnice',
			contractInformations: 'Informacije o ugovoru',
			hourlyRates: 'Satnice (€):',
			brevetInformations: 'Informacije o zamjeni breveta',
			candidateDocuments: 'Dokumenti kandidata',
			consents: 'Privole',
			concessions: 'Koncesije',
			editingDocument: 'Ažuriranje dokumenta',
			newDocument: 'Novi dokument',
			noClosedInspections: 'Nema zatvorenih kontrola.',
			plannedCourseInformations: 'Informacije o planiranom tečaju',
			courseSelection: 'Odabir tečaja',
			coursePlanning: 'Planiranje tečaja',
			courseManagment: 'Upravljanje tečajem',
			recommendations: 'Preporuke',
			preregistrationInformations: 'Informacije o predupisu',
			preregistrated: 'Predupisani',
			registrated: 'Upisani',
			candidateManualRegistration: 'Ručni upis kandidata',
			costs: 'Troškovi',
			cost: 'Trošak',
			participants: 'Sudionici',
			schedule: 'Raspored',
			equipmentList: 'Popis opreme',
			noEquipment: 'Nema opreme',
			appointment: 'Termin',
			teachersOnCourse: 'Predavači na tečaju',
			activities: 'Aktivnosti',
			activity: 'Aktivnost',
			teacherAppointments: 'Termini predavača',
			teacherActivities: 'Aktivnosti predavača',
			teacherContracts: 'Ugovori predavača',
			candidateCourses: 'Tečajevi kandidata',
			candidate: 'Kandidat',
			candidates: 'Kandidati',
			myProfile: 'Moj profil',
			partnerCandidates: 'Kandidati partnera',
			partnerShips: 'Plovila partnera',
			noParticipants: 'Nema sudionika',
			issuedCertificates: 'Izdani certifikati',
			issuingCertificate: 'Izdavanje certifikata',
			course: 'Tečaj',
			certificate: 'Certifikat',
			noCandidates: 'Nema kandidata',
			weeklySchedule: 'Tjedni raspored',
			candidateCertificates: 'Certifikati kandidata',
			loyaltyInformations: 'Loyalty informacije',
			loyaltyTransactions: 'Loyalty transakcije',
			manuallyAdjustLoyaltyPoints: 'Ručno prilagodi Loyalty bodove',
			stats: 'Statistika',
			survey: 'Anketa',
			teacherRatings: 'Ocjene predavača',
			gantt: 'Mjesečni raspored',
			surveyAboutCandidateSatisfaction: 'ANKETA O ZADOVOLJSTVU POLAZNIKA',
			surveyAboutCandidateSatisfaction_eng: 'CUSTOMER SATISFACTION SURVEY',
			teacherDocuments: 'Dokumenti predavača',
			teacherNavigations: 'Navigacija predavača',
			newNavigation: 'Nova navigacija',
			editingNavigation: 'Ažuriranje navigacije',
			internalDocuments: 'Interni dokumenti',
			paymentContractInformations: 'Informacije o platnim ugovorima',
			items: 'Stavke',
			item: 'Stavka',
			guaranteedRemaining: 'Garantirano - preostalo',
			guaranteedSpent: 'Garantirano - potrošeno',
			transactions: 'Transakcije',
			bill: 'Račun',
			bills: 'Računi',
			choosePaymentContract: 'Odaberite platni ugovor',
			registration: 'Upis',
			candidatePaymentContracts: 'Platni ugovori kandidata',
			partnerPaymentContracts: 'Platni ugovori vanjskog partnera',
			statsCourses: 'Statistika tečajeva',
			statsCandidates: 'Statistika kandidata',
			statsPartners: 'Statistika vanjskih partnera',
			externalCertificate: 'Vanjski certifikat',
			approvals: 'Odobrenja',
			attendedCourses: 'Odslušani tečajevi',
			bulkLockingPaymentContracts: 'Grupno zaključavanje platnih ugovora',
		},
	};
}
